@if (!live?.length) {
    <ms-error [message]="sitecore.event.ErrNoEvents" [severity]="'info'"></ms-error>
} @else {
    <ng-container msScrolledToBottom [scrollContext]="'document'" (scrollAtBottom)="showUpcoming()">
        @for (current of live; track current.getState().id) {
            @if (current | async; as currentGrid) {
                <ms-grid [model]="currentGrid" [tracking]="tracking" [class.show-more-grid]="shouldShowMore(currentGrid.sport.id)"></ms-grid>
                @if (shouldShowMore(currentGrid.sport.id)) {
                    <div class="show-more-grid-footer ms-active-highlight" (click)="loadMore(currentGrid.sport.id, current)">
                        <div [class.spinner-img]="isEsportLoading">{{ sitecore.event.MoreEvents }}</div>
                        @if (!isEsportLoading) {
                            <div class="arrow">
                                <vn-icon name="theme-down" [size]="isEpcotEnabled ? '16' : '12'"></vn-icon>
                            </div>
                        }
                    </div>
                }
            }
        }
        @if (upcomingLoaded && upcoming) {
            <ms-live-upcoming-list [model]="upcoming" [tracking]="tracking"></ms-live-upcoming-list>
        }
    </ng-container>
}
